export function Spinner({ size = 16 }: { size?: number }) {
  const px = Math.max(12, size);
  return (
    <div
      style={{ width: px, height: px }}
      className="inline-block align-middle"
      aria-hidden
    >
      <svg className="animate-spin text-current" viewBox="0 0 24 24" fill="none" width={px} height={px}>
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
      </svg>
    </div>
  );
}
